module.exports = __webpack_public_path__ + "media/images/slider002-2407242d530919c172c558ba23266bb8.jpg";